<template>
    <div class="container-fluid">

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <v-app>
                        <v-container fluid>
                            <v-card elevation="2" outlined>
                                <v-card-title>
                                    <!--                                    v-if="$can('transaction_create')"-->

                                    <v-spacer/>
                                    {{ $route.meta.title }}
                                    <v-spacer/>


                                </v-card-title>
                                <v-divider/>

                                <div class="row">

                                    <div class="col-md-12 p-5">
                                        <data-table
                                            :data="userInfo"
                                            :columns="columns"
                                            :translate="translate"
                                            :per-page="[10, 25, 50, 100]"
                                            @on-table-props-changed="reloadTable"
                                        >

                                        </data-table>
                                    </div>
                                </div>
                            </v-card>
                        </v-container>
                    </v-app>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import Btn from "./Btn";

export default {
    data() {
        return {
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            url: 'authRequest',
            userInfo:{},
            tableProps: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            columns: [
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'نام',
                    name: 'name',
                    orderable: true,
                },
                {
                    label: 'نام کاربری',
                    name: 'username',
                    orderable: true,
                },
                {
                    label: 'تلفن',
                    name: 'phone',
                    orderable: true,
                },
              {
                label: 'تاریخ درخواست',
                name: 'updated_at',
                transform: (val) =>  {
                  return this.$options.filters.longDate(val.data.updated_at)
                }
              },
                {
                    label: 'نوع کاربر',
                    name: 'type',
                    orderable: true,
                    transform: (value, data) => {
                        return value.data.type == 'regular' ? 'شخص حقیقی' : 'شخص حقوقی';
                    }
                },

                {
                    label: 'عملیات',
                    name: 'actions',
                    component: Btn,
                    handler: this.showItem,
                    event: 'showItem',
                  meta: {
                    permission_prefix: 'user_',
                  }
                },
            ],
        }
    },
    created() {
        this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
        this.getUserInfo(this.url)
    },

    methods: {
        filterOnlyCapsText(value, search, item) {
            return value != null &&
                search != null &&
                typeof value === 'string' &&
                value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

        getUserInfo(url = this.url, params = this.tableProps) {
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            })
        },

        reloadTable(params) {
            this.getUserInfo(this.url, params)
        },

        showItem(data) {
            this.$router.push({name: 'user.confirmed.show', params: {id: data.id}})
        }
    }
}
</script>
